import * as React from 'react';
import { styled, classNamesFunction } from '../../../Utilities';
import { IconButton } from '../../../Button';
import { getStyles } from './TagItem.styles';
var getClassNames = classNamesFunction();
export var TagItemBase = function TagItemBase(props) {
  var theme = props.theme,
    styles = props.styles,
    selected = props.selected,
    disabled = props.disabled,
    enableTagFocusInDisabledPicker = props.enableTagFocusInDisabledPicker,
    children = props.children,
    className = props.className,
    index = props.index,
    onRemoveItem = props.onRemoveItem,
    removeButtonAriaLabel = props.removeButtonAriaLabel;
  var classNames = getClassNames(styles, {
    theme: theme,
    className: className,
    selected: selected,
    disabled: disabled
  });
  return React.createElement("div", {
    className: classNames.root,
    role: 'listitem',
    key: index,
    "data-selection-index": index,
    "data-is-focusable": (enableTagFocusInDisabledPicker || !disabled) && true
  }, React.createElement("span", {
    className: classNames.text,
    "aria-label": children
  }, children), React.createElement(IconButton, {
    onClick: onRemoveItem,
    disabled: disabled,
    iconProps: {
      iconName: 'Cancel',
      styles: {
        root: {
          fontSize: '12px'
        }
      }
    },
    className: classNames.close,
    ariaLabel: removeButtonAriaLabel
  }));
};
export var TagItem = styled(TagItemBase, getStyles, undefined, {
  scope: 'TagItem'
});